import FilterSidebar from '../FilterSidebar';

/**
 * Two-pane Filter Students shell (rail + results). Page still owns data.
 */
const StudentDirectoryLayout = ({ sidebarProps, toolbar, children }) => (
  <div className="grid grid-cols-1 lg:grid-cols-[minmax(260px,320px)_1fr] gap-4 items-start">
    <FilterSidebar {...sidebarProps} />
    <div className="min-w-0">
      {toolbar}
      {children}
    </div>
  </div>
);

export default StudentDirectoryLayout;
